<app-navigation-tab #navBar [fireInitialEvent]="false" class="nav-bar" [tabConfig]="tabConfig"
    (onTabChanged)="changeTab($event.tab.title)" [selectedTabIndex]="selectedTabIndex">
</app-navigation-tab>
@if(selectedTab === "Device Reporting"){
<div class="header-container">
    <app-generic-table-header (dateRangeChange)="updateDates($event)" (exportPressed)="exportData()"
        [config]="headerConfig"></app-generic-table-header>
</div>
@if(loading){
<mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
}@else{
@if(data && data[id]&&data[id].Data){
<div class="data-cards">
    @if (Temperature){
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Minimum Temperature</td>
                        <td>{{Temperature.Min}} &deg;C</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Maximum Temperature</td>
                        <td>{{Temperature.Max}} &deg;C</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Average Temperature</td>
                        <td>{{(Temperature.Total/Temperature.NumberOfEntries)| number : '1.2-2'}} &deg;C</td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if(DeviceUptime)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Minimum Device Uptime</td>
                        <td>{{convertFromSeconds(DeviceUptime.Min)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Maximum Device Uptime</td>
                        <td>{{convertFromSeconds(DeviceUptime.Max)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Average Device Uptime</td>
                        <td>{{convertFromSeconds(DeviceUptime.Total===0?0:(DeviceUptime.Total/DeviceUptime.NumberOfEntries))}}
                        </td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if(DeviceDowntime)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Minimum Device Downtime</td>
                        <td>{{convertFromSeconds(DeviceDowntime.Min)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Maximum Device Downtime</td>
                        <td>{{convertFromSeconds(DeviceDowntime.Max)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Average Device Downtime</td>
                        <td>{{convertFromSeconds(DeviceDowntime.Total===0?0:(DeviceDowntime.Total/DeviceDowntime.NumberOfEntries))}}
                        </td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if(ConnectionUptime)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Minimum Connection Uptime</td>
                        <td>{{convertFromSeconds(ConnectionUptime.Min)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Maximum Connection Uptime</td>
                        <td>{{convertFromSeconds(ConnectionUptime.Max)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Average Connection Uptime</td>
                        <td>{{convertFromSeconds(ConnectionUptime.Total===0?0:(ConnectionUptime.Total/ConnectionUptime.NumberOfEntries))}}
                        </td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if(ConnectionDowntime)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Minimum Connection Downtime</td>
                        <td>{{convertFromSeconds(ConnectionDowntime.Min)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Maximum Connection Downtime</td>
                        <td>{{convertFromSeconds(ConnectionDowntime.Max)}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Average Connection Downtime</td>
                        <td>{{convertFromSeconds(ConnectionDowntime.Total===0?0:(ConnectionDowntime.Total/ConnectionDowntime.NumberOfEntries))}}
                        </td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if (SignalStrength)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Minimum signal</td>
                        <td>{{SignalStrength.Min}} dB</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Maximum signal</td>
                        <td>{{SignalStrength.Max}} dB</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Average signal</td>
                        <td>{{(SignalStrength.Total/SignalStrength.NumberOfEntries)| number : '1.2-2'}} dB</td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if (WirelessClientCount)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Minimum Wireless Client Count</td>
                        <td>{{WirelessClientCount.Min}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Maximum Wireless Client Count</td>
                        <td>{{WirelessClientCount.Max}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Average Wireless Client Count</td>
                        <td>{{(WirelessClientCount.Total/WirelessClientCount.NumberOfEntries)| number : '1.2-2'}}</td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if (DataUsage)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    @for(item of DataUsage| keyvalue;track item){
                    <tr>
                        <td style="float:left;">{{item.key}}</td>
                        <td>{{item.value| number : '1.2-2'}} MB</td>
                    </tr>
                    }
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
    @if(wanSchedulingEnabled)
    {
    <mat-card class="card">
        <mat-card-content>
            <div class="table-container">
                <table>
                    <tr>
                        <td style="float:left;">Wan Enabled</td>
                        <td>{{wanSchedulingEnabled ? 'Yes' : 'No'}}</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Total TX</td>
                        <td>{{WANTotalTx | number : '1.2-2'}} MB</td>
                    </tr>
                    <tr>
                        <td style="float:left;">Total RX</td>
                        <td>{{WANTotalRx | number : '1.2-2'}} MB</td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    }
</div>
}
}
}@else if (selectedTab === "WAN Reporting") {
    @if(wanSchedulingEnabled) {
    <div class="header-container">
        <app-generic-table-header (dateRangeChange)="updateWANDates($event)" (exportPressed)="exportWANData()"
            [config]="headerConfig"></app-generic-table-header>
    </div>
    @if(loading){
        <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
    }@else{
        @if(wanData && wanData[id]&&wanData[id].Data){
        <div class="data-cards">
            @if(WANUptime)
            {
            <mat-card class="card">
                <mat-card-content>
                    <div class="table-container">
                        <table>
                            <tr>
                                <td style="float:left;">Minimum Device Uptime</td>
                                <td>{{convertFromSeconds(WANUptime.Min)}}</td>
                            </tr>
                            <tr>
                                <td style="float:left;">Maximum Device Uptime</td>
                                <td>{{convertFromSeconds(WANUptime.Max)}}</td>
                            </tr>
                            <tr>
                                <td style="float:left;">Average Device Uptime</td>
                                <td>{{convertFromSeconds(WANUptime.Total===0?0:(WANUptime.Total/WANUptime.NumberOfEntries))}}
                                </td>
                            </tr>
                        </table>
                    </div>
                </mat-card-content>
            </mat-card>
            }
            @if(WANDowntime)
            {
            <mat-card class="card">
                <mat-card-content>
                    <div class="table-container">
                        <table>
                            <tr>
                                <td style="float:left;">Minimum Device Downtime</td>
                                <td>{{convertFromSeconds(WANDowntime.Min)}}</td>
                            </tr>
                            <tr>
                                <td style="float:left;">Maximum Device Downtime</td>
                                <td>{{convertFromSeconds(WANDowntime.Max)}}</td>
                            </tr>
                            <tr>
                                <td style="float:left;">Average Device Downtime</td>
                                <td>{{convertFromSeconds(WANDowntime.Total===0?0:(WANDowntime.Total/WANDowntime.NumberOfEntries))}}
                                </td>
                            </tr>
                        </table>
                    </div>
                </mat-card-content>
            </mat-card>
            }
            <mat-card class="card">
                <mat-card-content>
                    <div class="table-container">
                        <table>
                            <tr>
                                <td style="float:left;">Total TX</td>
                                <td>{{WANTotalTx | number : '1.2-2'}} MB</td>
                            </tr>
                            <tr>
                                <td style="float:left;">Total RX</td>
                                <td>{{WANTotalRx | number : '1.2-2'}} MB</td>
                            </tr>
                        </table>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        }
    }
    }@else {
        <p>WAN reporting is currently disabled for this device.</p>
    }
}